export class ProductsPayment {
    personID: number;
    totalCost: number;
    salesTax: number;
    paymentType: string;
    cardNumber: string;
    cardCode: string;
    expirationDate: string;
    payerName: string;
    accountNumber: string;
    routingNumber: string;
    accountType: string;
    nameOnAccount: string;
    address: string;
    city: string;
    state: string;
    zip: string;
    countryId: string;
    createdBy: string;
    statusCode: string;
    Details: ProductDetail[];
    dataDescriptor = null;
    dataValue = null;
}

export class ProductDetail {
    serviceCodeID: string;
    quantity: number;
    cost: number;
    cvRequest: CredentialVerificationRequest;
    pinInitials: string;
    renewalYear: string;    
    annualFeeCharityId: number;    
}

export class CredentialVerificationRequest {
    cvRequestFor: string;
    agencyID: string;
    name: string;
    addressLine1: string;
    addressLine2: string;
    addressLine3: string;
    city: string;
    stateCode: string;
    zip: string;
    zip4: string;
    countryId: string;
    email: string;
}
